import apiClient from '../client';
import {
  LoginRequest,
  LoginResponse,
  RefreshTokenResponse,
  LogoutResponse,
} from '../types/auth.types';

export const authApi = {
  // Login
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const organizationId = process.env.REACT_APP_ORGANIZATION_ID || '';
    const loginData = {
      ...credentials,
      organizationId,
    };
    const response = await apiClient.post<LoginResponse>('/auth/login', loginData);
    return response.data;
  },

  // Refresh token
  refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
    const response = await apiClient.post<RefreshTokenResponse>('/auth/refresh-token', {
      refreshToken,
    });
    return response.data;
  },

  // Logout
  logout: async (): Promise<LogoutResponse> => {
    const response = await apiClient.post<LogoutResponse>('/auth/logout');
    return response.data;
  },

  // Get current user info (optional - if API provides this endpoint)
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
};
